export default require('../../client/death/cart/CartPage').default;
